import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=47addb38&scoped=true"
import script from "./DetailProduct.vue?vue&type=script&lang=ts"
export * from "./DetailProduct.vue?vue&type=script&lang=ts"
import style0 from "./DetailProduct.vue?vue&type=style&index=0&id=47addb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47addb38",
  null
  
)

export default component.exports